import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';

import DeliveryTypesFormContainer from './DeliveryTypesFormContainer';
import DeliveryTypesListContainer from './DeliveryTypesListContainer';

import { isAdmin } from '../../utils';

import Route from '../../routes/SentryRoute';

const DeliveryTypesManagementRouter = ({ match }) => {
  if (!isAdmin()) return null;
  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/`}
        component={DeliveryTypesListContainer}
      />
      <Route
        path={`${match.path}/:id`}
        component={DeliveryTypesFormContainer}
      />
    </Switch>
  );
};

DeliveryTypesManagementRouter.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default DeliveryTypesManagementRouter;
